export const AssetVI = {
    "asset": "Tài sản",
    "handover": "Cấp phát tài sản",
    "invoke": "Thu hồi tài sản",
    "depreciation": "Tài sản khấu hao",
    "store" : "Kho",
    "general" : "Cài đặt chung",
    "position" : "Vị trí tài sản",
    "unit" : "Đơn vị",
    "type" : "Loại tài sản",
    "properties" : "Thuộc tính",
    "supplier" : "Nhà cung cấp",
    "notification": "Thông báo thu hồi"
}